module.exports = __webpack_public_path__ + "img/IMG_9321_L_WoodMatted_MockedUp.c1f54e40.jpg";